module.exports = __webpack_public_path__ + "static/media/onepay-darkcontext.14cc0c5a.svg";